/**
 * 创建复合选择意图在运行时事务中的稳定语义键。
 *
 * @param targetSketchId 目标草图持久 ID。
 * @param intentId 创建时选择意图 ID。
 * @returns 批次规划与派生创建/删除共同使用的语义键。
 */
export function createSketchEntityReferenceIntentBatchKey(
	targetSketchId: string,
	intentId: string,
): string {
	return `${targetSketchId}::intent::${intentId}`;
}

/**
 * 创建独立引用在运行时事务中的稳定语义键。
 *
 * @param targetSketchId 目标草图持久 ID。
 * @param referenceId 引用记录 ID。
 * @returns 独立引用语义键。
 */
export function createSketchEntityReferenceSingleBatchKey(
	targetSketchId: string,
	referenceId: string,
): string {
	return `${targetSketchId}::reference::${referenceId}`;
}
